var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJobListingType = function SvgJobListingType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.75 4.75V4H3v.75zm16.5 0H21V4h-.75zm-16.5 15.5H3V21h.75zM8.5 2.75V2H7v.75zm8.5 0V2h-1.5v.75zm2.5 6v.75H21v-.75zM8.75 21h.75v-1.5h-.75zm-5-15.5h4V4h-4zm4 0h8.5V4h-8.5zm8.5 0h4V4h-4zM4.5 20.25V4.75H3v15.5zm4-15.5v-2H7v2zm8.5 0v-2h-1.5v2zm2.5 0v4H21v-4zM8.75 19.5h-5V21h5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 5.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M17 14.75V17l1.75 1.75"
  })));
};
export default SvgJobListingType;